import(/* webpackMode: "eager" */ "/home/u453023306/domains/digitalmoney.tv/hbuilds/source/src/app/markets/page.tsx");
